import {
  MAPPED_ROLES_MANAGER,
  ROLES_MANAGER,
} from 'containers/ManagerManagement/constant';

export const renderRoles = (userRoles: any) => {
  return Object.entries(MAPPED_ROLES_MANAGER)
    .filter(([key, _]) => userRoles[key] === true)
    .map(([, roleName]) => roleName + ' ,');
};

export const formatPayload = (userRoles: any, existingRole: any) => {
  const formattedRoles = Object.entries(MAPPED_ROLES_MANAGER)
    .filter(([key, _]) => userRoles.includes(_))
    .map(([key, _]) => {
      return { [`${key}`]: true };
    });
  const formattedExistingRoles = Object.entries(MAPPED_ROLES_MANAGER)
    .filter(([key, _]) => existingRole[key] === true && !userRoles.includes(_))
    .map(([key, _]) => {
      return { [`${key}`]: false };
    });

  return {
    ...formattedRoles.reduce((acc, obj) => ({ ...acc, ...obj }), {}),
    ...formattedExistingRoles.reduce((acc, obj) => ({ ...acc, ...obj }), {}),
  };
};

export const allowedRoles = (existingRole: any) => {
  if (existingRole.some((el: any) => ROLES_MANAGER.includes(el))) {
    return ['Manager', 'Gestionnaire dossier important'];
  } else {
    return ROLES_MANAGER;
  }
};
export const formatExistingRoles = (userRoles: any) => {
  return Object.entries(MAPPED_ROLES_MANAGER)
    .filter(([key, _]) => userRoles[key] === true)
    .map(([, roleName]) => roleName);
};
